/* eslint-disable max-len */
import { NavigateFunction } from 'react-router-dom';
import { fillInRouteParams } from '../routes/RouteHelper';
import { SC_ROUTE_PATHS } from './SCProjectConfig';


export class SCRouteHelper {

    private static instance: SCRouteHelper;

    public static getInstance (navigate?: NavigateFunction) {
        // create a new Route Helper instance if we have not create one yet or if we have a 'history' object now but didn't have one before
        if (!SCRouteHelper.instance || (navigate && !SCRouteHelper.instance.navigate)) {
            SCRouteHelper.instance = new SCRouteHelper(navigate);
        }
        return SCRouteHelper.instance;
    }


    private navigate: NavigateFunction | undefined;

    private constructor (navigate?: NavigateFunction) {
        this.navigate = navigate;
    }

    public navigateTo = (url: string, replace: boolean = false, delay: number = 0) => {
        if (delay > 0) {
            // If there is a delay required, wait 'delay' ms and then call route again with the same params but without delay next time.
            window.setTimeout(() => {
                this.navigateTo(url, replace, 0);
            }, delay);
            return;
        }

        if (this.navigate) {
            this.navigate(url, { replace });
        }
    };

    /**
     * Get the Sensor Module page URL
     */
    public getHomeSensorModuleDetailsPageUrl (params: {
        readonly projectId: number;
        readonly moduleId: string;
        readonly homeId: number | undefined;
        readonly userId?: number | undefined;
    }) {
        if (params.userId) {
            return fillInRouteParams(SC_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId_SENSOR_MODULES_$moduleId as string, params);
        }
        return fillInRouteParams(SC_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId_SENSOR_MODULES_$moduleId as string, params);
    }

    /**
     * Go to the custom feature page that show sensor modules for a selected project and device
     */
    public gotoHomeSensorModuleDetailsPage (params: {
        readonly projectId: number;
        readonly moduleId: string;
        readonly homeId: number | undefined;
        readonly userId?: number | undefined;
    }, replace: boolean = false, delay: number = 0) {
        this.navigateTo(this.getHomeSensorModuleDetailsPageUrl(params), replace, delay);
    }

    /**
     * Get the Sensor Module page URL
     */
    public getDeviceSensorModuleDetailsPageUrl (params: {
        readonly projectId: number;
        readonly moduleId: string;
        readonly deviceId: number | undefined;
        readonly homeId?: number | undefined;
        readonly userId?: number | undefined;
    }) {
        if (params.userId && params.homeId) {
            return fillInRouteParams(SC_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId_DEVICES_$deviceId_SENSOR_MODULES_$moduleId as string, params);
        }
        if (params.homeId) {
            return fillInRouteParams(SC_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId_DEVICES_$deviceId_SENSOR_MODULES_$moduleId as string, params);
        }
        return fillInRouteParams(SC_ROUTE_PATHS.PROJECTS_$projectId_DEVICES_$deviceId_SENSOR_MODULES_$moduleId as string, params);
    }

    /**
     * Go to the custom feature page that show sensor modules for a selected project and device
     */
    public gotoDeviceSensorModuleDetailsPage (params: {
        readonly projectId: number;
        readonly moduleId: string;
        readonly deviceId: number | undefined;
        readonly homeId?: number | undefined;
        readonly userId?: number | undefined;
    }, replace: boolean = false, delay: number = 0) {
        this.navigateTo(this.getDeviceSensorModuleDetailsPageUrl(params), replace, delay);
    }



    /**
     * Get the Sensor Module page URL
     */
    public getSensorModuleDetailsPageUrl (params: {
        readonly projectId: number;
        readonly moduleId: string;
        readonly deviceId?: number | undefined;
        readonly homeId?: number | undefined;
        readonly userId?: number | undefined;
    }) {
        if (params.userId && params.homeId && params.deviceId) {
            return fillInRouteParams(SC_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId_DEVICES_$deviceId_SENSOR_MODULES_$moduleId as string, params);
        }
        if (params.userId && params.homeId) {
            return fillInRouteParams(SC_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId_SENSOR_MODULES_$moduleId as string, params);
        }
        if (params.homeId && params.deviceId) {
            return fillInRouteParams(SC_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId_DEVICES_$deviceId_SENSOR_MODULES_$moduleId as string, params);
        }
        if (params.homeId) {
            return fillInRouteParams(SC_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId_SENSOR_MODULES_$moduleId as string, params);
        }
        return fillInRouteParams(SC_ROUTE_PATHS.PROJECTS_$projectId_DEVICES_$deviceId_SENSOR_MODULES_$moduleId as string, params);
    }

    /**
     * Go to the custom feature page that show sensor modules for a selected project and device
     */
    public gotoSensorModuleDetailsPage (params: {
        readonly projectId: number;
        readonly moduleId: string;
        readonly deviceId?: number | undefined;
        readonly homeId?: number | undefined;
        readonly userId?: number | undefined;
    }, replace: boolean = false, delay: number = 0) {
        this.navigateTo(this.getSensorModuleDetailsPageUrl(params), replace, delay);
    }
}
